export interface IWebServiceAuthentication {
  authorize(): Promise<void>;
  getServiceURL(url: string): string;
}

export class BKGWebserviceAuthentication implements IWebServiceAuthentication {
  private APIKey: string;
  private token: string | null = null;

  constructor(APIKey: string) {
    this.APIKey = APIKey;
  }

  public async authorize(){
    const response = await fetch(`https://sg.geodatenzentrum.de/gdz_getSession?bkg_appid=${this.APIKey}&domain=mapview.hydrotec.de`);
    if (!response.ok) {
        throw new Error("Fehler beim Initialisieren des Session-Token");
    }
    this.token = await response.text();
  }

  public getServiceURL(url: string): string {
    return url.split("?")[0] + "__" + this.token;
  }
}